import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { constants, snowplow } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'
import injectGlobals from 'decorators/injectGlobals'

import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'

import ContinueCancellation from '../ContinueCancellation/ContinueCancellation'

import messages from './messages'
import s from './PauseSubscriptionModal.scss'


class PauseSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    isPauseOneMonthEnabled: PropTypes.bool,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.PauseSubscription,
  }

  continueCancellation = () => {
    this.close()
    actions.models.modals.open(constants.modals.cancelSubscription.OneLastQuestion)
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  trackCloseModal = (action) => {
    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'pause subscription',
      action,
    }, false)
  }

  handleGoBackClick = () => {
    this.trackCloseModal('go back')
    this.close()
  }

  handleSuccessPauseSubscription = () => {
    actions.models.modals.open(constants.modals.pauseSubscription.PauseSuccess)
    actions.models.subscription.fetchDataAfterPause()
  }

  handlePauseClick = () => {
    const { isPauseOneMonthEnabled } = this.props

    this.trackCloseModal('pause subscription')

    actions.models.ui.showRequestLoader()

    if (isPauseOneMonthEnabled) {
      actions.models.subscription.skipMonths({ count: 1, limitedPause: isPauseOneMonthEnabled })
        .finally(() => {
          actions.models.ui.hideRequestLoader()
          this.close()
        })
        .then((refund) => {
          if (refund) {
            actions.models.modals.open(constants.modals.cancelSubscription.RefundOnTheDayOfCharge, {
              ...refund,
              onClose: () => actions.models.modals.open(constants.modals.pauseSubscription.PauseOneMonthSuccess),
            })

            return
          }

          actions.models.modals.open(constants.modals.pauseSubscription.PauseOneMonthSuccess)
        }, () => {})
    }
    else {
      actions.models.subscription.pause()
        .finally(() => {
          actions.models.ui.hideRequestLoader()
          this.close()
        })
        .then((refund) => {
          if (refund) {
            actions.models.modals.open(constants.modals.cancelSubscription.RefundOnTheDayOfCharge, {
              ...refund,
              onClose: this.handleSuccessPauseSubscription,
            })

            return
          }

          this.handleSuccessPauseSubscription()
        }, () => {})
    }
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
        onClose={this.handleCloseModal}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
        <div className={s.buttons}>
          <Button className={s.button} brand title={messages.buttonBack} onClick={this.handleGoBackClick} />
          <Button className={s.button} brand title={messages.buttonPause} onClick={this.handlePauseClick} />
        </div>
        <ContinueCancellation onClick={this.continueCancellation} />
      </Modal>
    )
  }
}


export default injectGlobals(({ getFeatureToggle }) => ({
  isPauseOneMonthEnabled: getFeatureToggle(constants.features.pauseOneMonth),
}))(PauseSubscriptionModal)
